import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const useTabPersistence = (storageKey, defaultFilters = {}) => {
  const { state } = useLocation()

  const getPersistedTabIndex = () => {
    if (state?.activeTabIndex !== undefined) {
      return state.activeTabIndex
    }
    const stored = localStorage.getItem(`${storageKey}_activeTabIndex`)
    return stored ? parseInt(stored) : 0
  }

  const getPersistedChildTabIndex = () => {
    if (state?.activeChildTabIndex !== undefined) {
      return state.activeChildTabIndex
    }
    const stored = localStorage.getItem(`${storageKey}_activeChildTabIndex`)
    return stored ? parseInt(stored) : 0
  }

  const getPersistedFilters = () => {
    const stored = localStorage.getItem(`${storageKey}_filters`)
    if (stored) {
      try {
        return JSON.parse(stored)
      } catch (e) {
        console.warn(`Failed to parse stored filters for ${storageKey}:`, e)
        return defaultFilters
      }
    }
    return defaultFilters
  }

  const [activeTabIndex, setActiveTabIndex] = useState(getPersistedTabIndex())
  const [activeChildTabIndex, setActiveChildTabIndex] = useState(getPersistedChildTabIndex())
  const [filters, setFilters] = useState(getPersistedFilters())

  useEffect(() => {
    localStorage.setItem(`${storageKey}_activeTabIndex`, activeTabIndex.toString())
  }, [activeTabIndex, storageKey])

  useEffect(() => {
    localStorage.setItem(`${storageKey}_activeChildTabIndex`, activeChildTabIndex.toString())
  }, [activeChildTabIndex, storageKey])

  useEffect(() => {
    localStorage.setItem(`${storageKey}_filters`, JSON.stringify(filters))
  }, [filters, storageKey])

  return {
    activeTabIndex,
    setActiveTabIndex,
    activeChildTabIndex,
    setActiveChildTabIndex,
    filters,
    setFilters
  }
}

export const getTabState = (storageKey) => {
  const activeTabIndex = localStorage.getItem(`${storageKey}_activeTabIndex`) || '0'
  const activeChildTabIndex = localStorage.getItem(`${storageKey}_activeChildTabIndex`) || '0'
  
  return {
    activeTabIndex: parseInt(activeTabIndex),
    activeChildTabIndex: parseInt(activeChildTabIndex)
  }
}
